/*eslint-disable*/
import { configureStore } from '@reduxjs/toolkit'
import errorReducer from './reducers/errorSlice'
import userProfileReducer from './reducers/userProfile'
import groupsReducer from './reducers/groupsSlice'
import usersReducer from './reducers/usersSlice'
import uploadRequestsReducer from './reducers/uploadRequestsSlice'
import uploadStatusReducer from './reducers/uploadStatusSlice'
import userActivitiesReducer from './reducers/userActivitiesSlice'
import healthCheckReducer from './reducers/healthCheckSlice'
import userBannerReducer from './reducers/userBannerSlice'

const store = configureStore({
  reducer: {
    error: errorReducer,
    userProfile: userProfileReducer,
    groups: groupsReducer,
    users: usersReducer,
    uploadRequests: uploadRequestsReducer,
    uploadStatus: uploadStatusReducer,
    userActivities: userActivitiesReducer,
    healthCheck: healthCheckReducer,
    userBanner: userBannerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
